// Import the functions you need from the SDKs you need
import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getFirestore, type Firestore } from 'firebase/firestore';

// Firebase configuration using environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Check if we're in development mode
export const isDevelopmentMode = import.meta.env.VITE_DEVELOPMENT_MODE === 'true';

console.log('[Firebase] Configuration check:', {
  apiKey: firebaseConfig.apiKey ? 'SET' : 'MISSING',
  authDomain: firebaseConfig.authDomain || 'MISSING',
  projectId: firebaseConfig.projectId || 'MISSING',
  storageBucket: firebaseConfig.storageBucket || 'MISSING',
  messagingSenderId: firebaseConfig.messagingSenderId || 'MISSING',
  appId: firebaseConfig.appId ? 'SET' : 'MISSING',
  isDevelopmentMode
});

// Initialize Firebase only if not in development mode and config is complete
let app: FirebaseApp | null = null;
let db: Firestore | null = null;

if (!isDevelopmentMode) {
  // Check if all required config values are present
  const missingConfigs = [];
  if (!firebaseConfig.apiKey) missingConfigs.push('VITE_FIREBASE_API_KEY');
  if (!firebaseConfig.authDomain) missingConfigs.push('VITE_FIREBASE_AUTH_DOMAIN');
  if (!firebaseConfig.projectId) missingConfigs.push('VITE_FIREBASE_PROJECT_ID');
  if (!firebaseConfig.storageBucket) missingConfigs.push('VITE_FIREBASE_STORAGE_BUCKET');
  if (!firebaseConfig.messagingSenderId) missingConfigs.push('VITE_FIREBASE_MESSAGING_SENDER_ID');
  if (!firebaseConfig.appId) missingConfigs.push('VITE_FIREBASE_APP_ID');

  if (missingConfigs.length > 0) {
    console.error('[Firebase] Missing required environment variables:', missingConfigs);
    console.error('[Firebase] Please check your .env file and ensure all variables are set');
  } else {
    try {
      console.log('[Firebase] Initializing Firebase with project:', firebaseConfig.projectId);
      app = initializeApp(firebaseConfig);
      db = getFirestore(app);
      console.log('[Firebase] Successfully initialized Firebase and Firestore');
    } catch (error) {
      console.error('[Firebase] Initialization failed:', error);
      app = null;
      db = null;
    }
  }
} else {
  console.log('[Firebase] Running in development mode - Firebase disabled');
  app = null;
  db = null;
}

export { db };
export default app;
